export default __webpack_public_path__ + "static/media/i155vp.3dd5b1d9.webp";